module.exports = __webpack_public_path__ + "img/start.98fce9dd.png";